import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/legal/LegalLayout";
import { LegalP, LegalSection, LegalUl } from "@/components/legal/LegalProse";
import { OperatorContact } from "@/components/legal/OperatorContact";
import { CONTACT, OPERATOR, PAYMENTS } from "@/lib/legal";
import { tw } from "@/lib/theme";

export function RefundCancellationPage() {
  return (
    <LegalLayout
      title="Refund and Cancellation Policy"
      subtitle={`How refunds and subscription cancellations work on ${OPERATOR.product}.`}
    >
      <LegalSection title="Overview">
        <LegalP>
          {OPERATOR.product} accepts online payments in Indian Rupees (INR) through{" "}
          <strong>{PAYMENTS.provider}</strong> (UPI, cards, and netbanking). This policy explains
          when you may request a refund and how to cancel recurring creator subscriptions. We do{" "}
          <strong>not</strong> sell virtual currency, wallet credits, or resellable tokens.
        </LegalP>
        <OperatorContact />
      </LegalSection>

      <LegalSection title="What you can pay for">
        <LegalUl
          items={[
            "Creator tips — optional one-time support.",
            "Creator subscriptions — recurring monthly access to supporter-only posts.",
            "Content unlocks — one-time payment for a specific paid post or drop.",
            "Promoted posts — optional ad campaigns for creators (separate checkout).",
          ]}
        />
      </LegalSection>

      <LegalSection title="Refunds">
        <LegalUl
          items={[
            "Prices are shown in INR before you confirm payment.",
            "Failed or abandoned checkouts are not charged.",
            "Duplicate charges or technical errors: email support within 7 days with your Cashfree order/payment reference.",
            "Unauthorized transactions: report immediately; we may suspend the account pending review.",
            "Completed tips, subscriptions, and digital unlocks are generally non-refundable once access is delivered, except where applicable law requires a refund.",
            "Approved refunds are processed to the original payment method through Cashfree where possible. Refunds may take 5–10 business days depending on your bank or UPI app.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Subscription cancellation">
        <LegalP>
          Creator subscriptions renew monthly until you cancel. You may cancel at any time; access
          continues until the end of the current paid billing period unless stated otherwise at
          checkout.
        </LegalP>
        <LegalUl
          items={[
            "In the Android app: open the creator profile → Subscribed → Manage subscription → Cancel.",
            "On the web: open Settings → Subscriptions, or the creator profile → Subscribed → manage and cancel.",
            "If you cannot cancel in-app, email support@daywia.com from your registered email with the creator username and “Cancel subscription” in the subject.",
            "After cancellation, no further charges are made for that subscription. Previously authorised UPI mandates or card debits for future cycles are stopped per Cashfree and your bank’s rules.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Chargebacks and disputes">
        <LegalP>
          If you dispute a charge with your bank before contacting us, we may provide transaction
          records to {PAYMENTS.providerShort} and the payment network. Contact us first at{" "}
          <a href={`mailto:${CONTACT.support}`} className={tw.link}>
            {CONTACT.support}
          </a>{" "}
          with your registered email and payment reference so we can resolve the issue quickly.
        </LegalP>
      </LegalSection>

      <LegalSection title="Taxes">
        <LegalP>
          You are responsible for any taxes on creator earnings. We may collect tax information
          where required for creator payouts.
        </LegalP>
      </LegalSection>

      <LegalSection title="Related policies">
        <LegalP>
          See also our{" "}
          <Link to="/TermsandConditions" className={tw.link}>
            Terms and Conditions
          </Link>
          ,{" "}
          <Link to="/payments" className={tw.link}>
            Payments overview
          </Link>
          , and{" "}
          <Link to="/ContactUs" className={tw.link}>
            Contact Us
          </Link>
          .
        </LegalP>
      </LegalSection>
    </LegalLayout>
  );
}
